export const INITIAL_SEQUENCE_NUMBER = 0;
export const MAX_SINGLE_MESSAGE_SIZE = 15000;
export const RECONNECTION_TIMEOUT = 30000;
export const MAX_RETRY_COUNT = 3;
export const OUT_OF_SYNC_WAIT_TIME = 5000;
//# sourceMappingURL=value-constants.js.map